import { PageHero, Reveal, SectionHead, PhotoFrame } from "@/components/Shared";
import { IMG, usePageContent } from "@/lib/api";
import { PAGES } from "@/content/pageContent";
import { Handshake, Award, Users } from "lucide-react";

const CARD_ICONS = [Handshake, Users, Award];

export default function RotaryClub() {
  const c = usePageContent("rotary-club", PAGES["rotary-club"].defaults);
  const cards = [
    { title: c.card1Title, note: c.card1Note },
    { title: c.card2Title, note: c.card2Note },
    { title: c.card3Title, note: c.card3Note },
  ];
  return (
    <main>
      <PageHero eyebrow="Our Parent Club" title="Rotary Club of" italic="Bombay Central" image={IMG.forestMist}>
        <p className="text-sm leading-relaxed text-silver-dim sm:text-base">
          {c.heroText}
        </p>
      </PageHero>

      <section className="mx-auto max-w-7xl px-6 py-24" data-testid="rotary-about">
        <div className="grid items-start gap-14 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <SectionHead eyebrow="The Rotary Connection" title="Where we" italic="come from" grotesk />
            <Reveal delay={0.2}>
              <div className="mt-8 space-y-6 text-sm leading-relaxed text-white sm:text-base">
                <p>
                  <span className="font-semibold">{c.rotaractLead}</span> {c.rotaractBody}
                </p>
                <p>
                  <span className="font-semibold">{c.charterLead}</span> {c.charterBody}
                </p>
                <p>{c.history1}</p>
                <p>{c.history2}</p>
                <p>{c.history3}</p>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <PhotoFrame src={c.clubPhoto || null} label="Rotary Club of Bombay Central — photograph coming soon" className="aspect-[4/3] w-full bg-navy" />
          </Reveal>
        </div>

        <div className="mt-16 grid gap-5 sm:grid-cols-3" data-testid="rotary-cards">
          {cards.map((card, i) => {
            const Icon = CARD_ICONS[i] || Handshake;
            return (
              <Reveal key={`${card.title}-${i}`} delay={i * 0.08} className="h-full">
                <div className="card-line flex h-full flex-col p-8" data-testid={`rotary-card-${i}`}>
                  <Icon size={24} strokeWidth={1.4} className="text-ember" />
                  <h3 className="mt-6 font-grotesk text-xl font-semibold tracking-tight text-silver">{card.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-silver-muted">{card.note}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </main>
  );
}
